import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import TicketAvatar from 'flow/components/tickets/TicketAvatar';

import useAssigneeLabel, {
    AssigneeKey,
} from 'flow/components/tickets/Assignee/useAssigneeLabel';

interface Props {
    assigneeKey: AssigneeKey;
}

const TicketHeaderAssigneeButtonFace = ({ assigneeKey }: Props) => {
    const label = useAssigneeLabel(assigneeKey);

    return (
        <>
            <div className="p-0.5">
                {assigneeKey !== 'unassigned' ? (
                    <TicketAvatar
                        extensionKey={assigneeKey}
                        size="extraSmall"
                        lazyLoad={true}
                    />
                ) : (
                    <div className="flex size-5 items-center justify-center">
                        <Icon iconKey="pendingOutlined" size="1.25rem" />
                    </div>
                )}
            </div>
            <span className="line-clamp-1 break-all">{label}</span>
            <Icon iconKey="arrow_down" className="text-gray-600" />
        </>
    );
};

export default React.memo(TicketHeaderAssigneeButtonFace);
